import React from 'react'
// import PropTypes from 'prop-types'

// Components
import C13PeopleOrg from './../../../Components/Organisms/Personas/C13'
import C13PeopleOrgEmpresas from './../../../Components/Organisms/Personas/C13/indexEmp'
import C13PeopleOrgNegocios from './../../../Components/Organisms/Personas/C13/indexNeg'

function HomePeopleContainerUi(props) {
    
    function version(){
        return localStorage.getItem('version_comparador')
    }

    return (
        <>
            {
                version() === "EMP" ? <C13PeopleOrgEmpresas /> : version() === "NEG" ? <C13PeopleOrgNegocios /> : <C13PeopleOrg />
            }
        </>
    )
}


export default HomePeopleContainerUi
